import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "input-upload-wrapper" }
const _hoisted_3 = { class: "input-upload-wrapper" }
const _hoisted_4 = { class: "input-upload-wrapper" }
const _hoisted_5 = { class: "submit-button-wrapper" }

import { onMounted, reactive } from "vue";
import { ConfigService } from "@/api/services/ConfigService";
import { message } from "ant-design-vue";
import FileUpload from "@/components/FileUpload.vue";
import { Config } from "@/api/models/config/Config";


export default /*@__PURE__*/_defineComponent({
  __name: 'SystemView',
  setup(__props) {

const config = reactive<Config>({});

const handleConfig = async () => {
  const res = await ConfigService.ConfigGet();
  if (res.code === 0) {
    Object.assign(config, res.data);
  } else {
    message.error(res.msg);
  }
};

const submitConfig = async () => {
  const res = await ConfigService.Config(config);
  if (res.code === 0) {
    message.success("系统配置修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleConfig();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "payment-title" }, "微信支付配置", -1)),
    _createVNode(_component_a_form, {
      model: config,
      class: "payment-form",
      "label-col": { style: { width: '120px' } }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "客服二维码" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_input, {
                value: config.wx_customer,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((config.wx_customer) = $event)),
                placeholder: "请输入客服二维码",
                class: "custom-input"
              }, null, 8, ["value"]),
              _createVNode(FileUpload, {
                modelValue: config.wx_customer,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((config.wx_customer) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "互助群二维码" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_input, {
                value: config.wx_mutual_group,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((config.wx_mutual_group) = $event)),
                placeholder: "请输入互助群二维码",
                class: "custom-input"
              }, null, 8, ["value"]),
              _createVNode(FileUpload, {
                modelValue: config.wx_mutual_group,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((config.wx_mutual_group) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "快递查询api-key" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_input, {
                value: config.delivery_api_key,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((config.delivery_api_key) = $event)),
                placeholder: "快递查询api-key"
              }, null, 8, ["value"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: submitConfig,
        class: "submit-button"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("提交修改 ")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})